/**
 * Created by JasonChou on 17/6/13.
 */
import { confirmAlert } from '../components/Dialog'; // Import
import '../components/Dialog.css' //

export const toast = (msg, opts) => {
    confirmAlert({
        message: msg,
        buttons: [
            {
                label: '确定',
            },
        ]
    })
};


// WEBPACK FOOTER //
// ./src/utils/toastUtils.js